import React from 'react';
import PropTypes from 'prop-types';
import { Typography, TextField, } from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';

const FormAutocompleteField = ({ label, meta: { touched, error }, input, autocompleteData, placeholder }) => {
  const options = autocompleteData.map(s => ({ value: s.id, label: s.name }));
  return (
    <div style={{ marginTop: 8 }}>
      <Autocomplete
        getOptionLabel={option => option.label}
        onChange={(_, value) => input.onChange(value ? value.value : null)}
        options={options}
        value={input.value ? options.find(o => o.value === input.value) : null}
        noOptionsText="Nie znaleziono wpisów"
        renderInput={params => <TextField {...params} placeholder={placeholder} label={label} variant="standard" />}
      />
      {error && touched ? <Typography variant="caption" color="error">{error}</Typography> : null}
    </div>
  );
};

FormAutocompleteField.propTypes = {
  input: PropTypes.object,
  label: PropTypes.string,
  placeholder: PropTypes.string.isRequired,
  meta: PropTypes.object,
  autocompleteData: PropTypes.array.isRequired,
};

export default FormAutocompleteField;



// WEBPACK FOOTER //
// ./src/components/legacyForm/FormAutocompleteField.js